import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const isLoadingSelector = (statusKey) => (state) => state.claim[statusKey] === REDUX_ASYNC_STATUSES.LOADING;

export const selectClaim = (state) => state.claim?.claim;
export const selectClaimHistory = (state) => state.claim?.claimHistory;
export const selectClaimOrganizationsWithAccess = (state) => state.claim?.claimOrganizationsWithAccess;
export const selectClaimOrganizationsWithAccessLoading = isLoadingSelector('getClaimOrganizationsWithAccessStatus');

export const selectClaimLoading = isLoadingSelector('getClaimStatus');
export const selectClaimHistoryLoading = isLoadingSelector('getClaimHistoryStatus');

export const selectClaimPdfSummaryLoading = isLoadingSelector('getClaimPdfSummaryStatus');
export const selectClaimPDFSummaryAndUploadToMessageLoading = isLoadingSelector(
  'pdfClaimSummaryAndUploadToMessageStatus'
);
export const selectUpdateClaimStatusLoading = isLoadingSelector('updateClaimStatusStatus');
export const selectCreateClaimLoading = isLoadingSelector('createClaimStatus');
export const selectFetchLatestClaimDataAndUpdateItLoading = isLoadingSelector('fetchLatestClaimDataAndUpdateItStatus');
export const selectClaimRecommendedSettlementPayeeData = (state) => state.claim?.claimRecommendedSettlementPayeeData;
export const selectClaimRecommendedSettlementPayeeDataLoading = isLoadingSelector(
  'claimRecommendedSettlementPayeeDataStatus'
);

export const selectShowClaimEditOverviewModal = (state) => state.claim?.showClaimEditOverviewModal;
